/**
 * 卡券列表
 */
import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import styles from './CouponModal.module.scss';
import { XInput, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import { message } from 'antd';
import http from '@/assets/api/http';
import model from '@/reducers/user/member/model';
import { connect } from 'react-redux';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { autoPageNum, autopageSize } from '@/assets/config';
import TableContent from './components/TableContent';

class CouponModal extends React.Component {

    state = {
        confirmLoading: false,
        selectedRowKeys: [],
        selectedRows: [],

        couponName: undefined,
        couponType: {},
        beginTime: undefined,
        endTime: undefined,
    }

    componentDidMount() {
        this.props.getCouponTypeList({ enumName: 'CouponTypeEnum' });
        this._searchHandle();
    }

    _handleOk = () => {
        if (this.state.selectedRowKeys.length === 0) {
            message.warning('请选择一条模版记录');
            return;
        }

        http('/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.receiveCoupon', {
            userIds: this.props.data.ids,
            couponId: this.state.selectedRowKeys[0]
        }, 'POST').then(() => {
            message.success('操作成功');
            this.props.closeModal(true);
        }).catch((e) => {
            message.error(e.message);
        });
    }

    _handleCancel = () => {
        this.props.closeModal();
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, couponName, couponType, beginTime, endTime } = this.state;
        const query = {
            couponName,
            couponType: couponType.code,
            issueStartTime: beginTime,
            issueEndTime: endTime,
            issueStatus: 'ISSUING',
            status: '1',
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getCouponList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ couponName: undefined, couponType: {}, beginTime: undefined, endTime: undefined }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    // 表格复选输入
    _rowSelection = {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({ selectedRowKeys, selectedRows });
        },
    };

    render() {

        const { confirmLoading, couponName, couponType, beginTime, endTime } = this.state;
        const { couponList, couponTypeList } = this.props;

        return (
            <Modal
                width='80%'
                centered
                title='发放卡券'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.flexBoxContainer} style={{ height: 500 }}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='卡券名称'
                                placeholder='请输入'
                                value={couponName}
                                bindThis={this}
                                bindName='couponName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='卡券类型'
                                placeholder='请选择'
                                renderData={couponTypeList}
                                dataIndex='value'
                                keyIndex='code'
                                value={couponType.value}
                                bindThis={this}
                                bindName='couponType'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='发放时间'
                                value={beginTime}
                                bindThis={this}
                                bindName='beginTime'
                                showTime={false}
                                defaultTime='00:00:00'
                            />
                            <XDatePicker
                                style={{ marginRight: '20px' }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                showTime={false}
                                defaultTime='23:59:59'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableContent
                        rowSelection={this._rowSelection}
                        renderData={couponList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                </div>
            </Modal>
        );
    }
}

CouponModal.propTypes = {
    data: PropTypes.object, // 弹窗传递参数
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
    getCouponList: PropTypes.func,
    couponList: PropTypes.object,

    getCouponTypeList: PropTypes.func,
    couponTypeList: PropTypes.array,
};

const mapStateToProps = (state) => ({
    couponTypeList: state.member.getCouponTypeList,
    couponList: state.member.getCouponList
});
export default connect(mapStateToProps, { ...model.actions })(CouponModal);